/** The two readouts on an operator card. */

/** One labelled number: Booked / Upcoming / Handled. */
export function Figure({
  label,
  value,
  tone,
}: {
  label: string;
  value: number;
  tone?: string;
}) {
  return (
    <div className="rounded-md bg-nb-bg/60 px-1 py-1.5">
      <div className={`font-mono text-base tabular-nums ${tone ?? ""}`}>
        {value}
      </div>
      <div className="text-[10px] uppercase tracking-wide text-nb-text-3">
        {label}
      </div>
    </div>
  );
}

/** A labelled bar.
 *
 *  `pct` drives BOTH the fill and the printed number, which is the whole
 *  point of this component existing. The card used to fill a bar to the
 *  operator's completion and print their share of the campaign next to
 *  it — two measures rendered as one, invisible on the one operator
 *  whose share and completion happened to match.
 */
export function Meter({
  label,
  pct,
  className,
}: {
  label: string;
  pct: number;
  className: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="flex items-center justify-between text-xs text-nb-text-2">
        <span>{label}</span>
        <span className="font-mono tabular-nums text-nb-text">{pct}%</span>
      </span>
      <span
        className="h-1.5 overflow-hidden rounded-full bg-nb-bg/60"
        role="img"
        aria-label={`${label}: ${pct}%`}
      >
        <span
          className={`block h-full rounded-full ${className}`}
          style={{ width: `${pct}%` }}
        />
      </span>
    </div>
  );
}
